/* import __COLOCATED_TEMPLATE__ from './class-group-jns-club-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class ClubPointsCardComponent extends Component 
{
	@service store;
	@service csv;
	
	@tracked classGroup = null;
	@tracked className = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	
	@tracked selectedEntryText = null;//school data
	@tracked selectedEntryTextName = null;
	
	clubPoints = [100,95,90,85,80,75,72,69,66,63,60,58,56,54,52,50,48,46,44,42,40,38,36,34,32,30,28,26,24,22,20,19,18,17,16,15,14,13,12,11,10,9,8,7,6,5,4,3,2,1];
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			let results = (await this.classGroup.get('results')).slice();
			for(const result of results)
			{
				result.calculatedRacePoints = null;
			}
			this.calculateRacePoints();
		}
	}
	
	@action
	async selectClass(event)
	{
		if(event.target.value == '-')
		{
			this.className = null;
		}
		else
		{
			this.className = event.target.value;
			this.calculateRacePoints();
		}
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	selectEntryText(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedEntryText = null;
			this.selectedEntryTextName = null;
		}
		else
		{
			this.selectedEntryText = ptsCol;
			this.selectedEntryTextName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	async savePoints()
	{	
		if(this.classGroup && this.selectedRacePts != null && this.className != null && this.selectedRacePts != null)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib && result.className == this.className)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						await entry.save();
					}
				}
			}
		}
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedRacePts != null && this.className != null && this.selectedRacePts != null)
		{
			let results = (await this.classGroup.get('results')).slice();
			results = results.filter((result) =>
			{
				return result.className == this.className;
			});
			
			//sort by time
			results.sort(this.placeSort)
			//assign points
			let currentPoints = 0;
			let tiePoints = 0;
			for(const result of results)
			{
				if(result.status == "OK" && result.get(this.selectedEntryText) != null)
				{
					if(result.isTie)
					{
						if(tiePoints < this.clubPoints.length)
							result.calculatedRacePoints = this.clubPoints[tiePoints];
						currentPoints++;
					}
					else
					{
						if(currentPoints < this.clubPoints.length)
							result.calculatedRacePoints = this.clubPoints[currentPoints];
						currentPoints++;
						tiePoints = currentPoints;
					}
				}
			}
		}
	}
	
	placeSort(a,b)
	{
		return a.place-b.place;
	}
}